import React from 'react';
import PermissionGate from 'global/components/permission-gate';
import { withRouter } from 'react-router-dom';
import AssessmentTemplates from './assessmenttemplates';
import EditionList from './editions';
import Panels from '../../../global/components/panels';
import ScorecardList from './scorecards';
import TaskTypeList from '../task-types';
import { TradesList } from '../vendors/trades';
import { GridContainer, CenterContent } from 'global/components/perform-grid';

export default PermissionGate(
  withRouter((props) => {
    const panels = [
      { 
        title: 'Content Configuration',
        panels: [
          { id: 'task-types', title: 'Task Types', component: (p) => <TaskTypeList {...p} /> },
          { id: 'trade-types', title: 'Trade Types', component: (p) => <TradesList {...p} /> },
        ]
      },
      { 
        title: 'Content Management',
        panels: [
          { id: 'editions', title: 'Editions', component: (p) => <EditionList {...p} /> },
          // { id: 'scorecards', title: 'Scorecards', component: p => <AssessmentTemplates {...p} /> },
          { id: 'templates', title: 'Assessment Templates', component: (p) => <AssessmentTemplates {...p} /> },
          { id: 'scorecards', title: 'Scoring Criteria', component: (p) => <ScorecardList {...p} /> },
        ]
      }
    ]

    return (
      <GridContainer>
        <CenterContent fullWidth>
          {panels.map((p) => (
            <Panels key={p.title} title={p.title} panels={p.panels} defaultPanel={99} />
          ))}
        </CenterContent>
      </GridContainer>
    );
  })
);
